import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://neadfoxscgjeekvabnoz.supabase.co'
const supabaseAnonKey =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5lYWRmb3hzY2dqZWVrdmFibm96Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjI1NTAzNzEsImV4cCI6MjA3ODEyNjM3MX0.I-75-7vscLz73dZQWhWvYZB6TGqgZIiQRkNWOiel5dM'

// Create Supabase client with explicit session persistence settings
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // Store session in localStorage for persistence across page refreshes
    storage: window.localStorage,
    // Automatically refresh the token before it expires
    autoRefreshToken: true,
    // Persist the session to localStorage
    persistSession: true,
    // Detect session from URL (for email confirmations, password resets, etc.)
    detectSessionInUrl: true,
  },
})
